import React from 'react';
import { Link } from 'react-router-dom';
import { Github, Linkedin, Instagram, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-white/10 bg-black/50" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-2xl font-bold font-['Syne'] mb-4">Debojit</h3>
            <p className="text-sm text-muted-foreground">
              Creative graphic designer crafting visual experiences that tell stories.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider">Quick Links</h4>
            <div className="space-y-2">
              <Link to="/work" className="block text-sm text-muted-foreground hover:text-primary transition-colors" data-testid="footer-work-link">
                Work
              </Link>
              <Link to="/about" className="block text-sm text-muted-foreground hover:text-primary transition-colors" data-testid="footer-about-link">
                About
              </Link>
              <Link to="/contact" className="block text-sm text-muted-foreground hover:text-primary transition-colors" data-testid="footer-contact-link">
                Contact
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider">Connect</h4>
            <div className="flex space-x-4">
              <a href="https://github.com/debojit-dev0" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" data-testid="social-github">
                <Github size={20} />
              </a>
              <a href="https://www.linkedin.com/in/debojit-guchhait/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" data-testid="social-linkedin">
                <Linkedin size={20} />
              </a>
              <a href="https://www.instagram.com/debojit_dev14/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" data-testid="social-instagram">
                <Instagram size={20} />
              </a>
              <a href="mailto:thedevdebojit@gmail.com" className="text-muted-foreground hover:text-primary transition-colors" data-testid="social-email">
                <Mail size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-center text-sm text-muted-foreground">
          <p>© {currentYear} Designed & developed with passion — Debojit</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
